import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../abstract/api.service';
import { DashboardStats } from '../response-models/dashboard-stats.model';
import { isRecord } from '../utils/is-record';
import { countOrZero } from '../utils/wire-value-utils';

/** The admin dashboard's headline counts: GET /admin/dashboard/stats (hub `admin-dashboard-controller.ts`). */
@Injectable({ providedIn: 'root' })
export class DashboardService extends ApiService {
  constructor() {
    super('admin/dashboard');
  }

  getStats(): Observable<DashboardStats> {
    return this.request('GET', { path: 'stats' }, toStats);
  }
}

function toStats(data: unknown): DashboardStats {
  const source = isRecord(data) ? data : {};
  return {
    totalUsers: countOrZero(source['totalUsers']),
    activeDrones: countOrZero(source['activeDrones']),
    openTickets: countOrZero(source['openTickets']),
    activeOrganizations: countOrZero(source['activeOrganizations']),
  };
}
